import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";

import { Button, ButtonRow, ChatBubble, Heading } from "cai-fusion";
import { useNewTemplate } from "../contexts/NewTemplateContext";
import SymphonyFileHandler from "../components/symphonyFileHandler";

import Markdown from "react-markdown";

const avatarAI = require("../../../images/avatar-ai.png");

const SymphonyChatTemplatePage = () => {
    const { chatTemplate, setChatTemplate, executeTemplate } = useNewTemplate();
    const fileUploadRef = useRef(null);

    useEffect(() => {
        console.log("[CHATTEMPLATE] Selected template changed to: ", chatTemplate);
    }, [chatTemplate])

    const updatePromptField = (index, value) => {
        let editedChatTemplate = {...chatTemplate}
        editedChatTemplate.messageComponents[index].value = value;
        setChatTemplate({...editedChatTemplate});
    }

    const updatePromptFiles = (files) => {
        setChatTemplate({...chatTemplate, userAddedFiles: files});
    }

    return (
        <>
            <div className="col-md-12 l-mt-sm l-pb-xl">
                <Heading size={3}>{chatTemplate?.title ?? ""}</Heading>
                <p></p>
                <p className="a-muted-text">{chatTemplate?.description ?? ""}</p>
                {chatTemplate?.initialMessageText &&
                    <ChatBubble 
                        image={<img src={avatarAI} className="a-avatar__img a-avatar__img--square" />}
                        isAssistant
                        isReply
                        name="Symphony Assistant"
                    >
                        <p>
                            <Markdown>
                                {chatTemplate.initialMessageText}
                            </Markdown>
                        </p>
                    </ChatBubble>
                }
                {(chatTemplate?.messageComponents?.length > 0 || chatTemplate?.hasFileUpload) &&
                    <form className="o-nl-form l-mt-sm" ref={fileUploadRef}>
                        <p className="o-nl-form__text">
                            {chatTemplate?.messageComponents?.map((part, index) => {
                                if (part.type === "input") {
                                    return (
                                        <input
                                            key={`template-preview-${index}`}
                                            placeholder={part.text}
                                            type="text"
                                            className="o-nl-form__text-input"
                                            value={part.value}
                                            onChange={(e) => updatePromptField(index, e.target.value)}
                                        />
                                    );
                                } else if (part.type === "textarea") {
                                    return (
                                        <textarea
                                            key={`template-preview-${index}`}
                                            placeholder={part.text}
                                            className="a-textarea-input"
                                            rows="3"
                                            value={part.value}
                                            onChange={(e) => updatePromptField(index, e.target.value)}
                                        />
                                    );
                                } else if (part.type === "select") {
                                    return (
                                        <select 
                                            className="o-nl-form__select" 
                                            onChange={(e) => updatePromptField(index, e.target.value)}
                                            key={`template-preview-${index}`}
                                        >
                                            {part.options?.filter((option) => !(!option) && option != "").map((option) => (
                                                <option 
                                                    value={option} 
                                                    defaultValue={option === part.defaultValue}
                                                    key={`template-preview-${index}-${option}`}
                                                >
                                                    {option}
                                                </option>
                                            ))}
                                        </select>
                                    );
                                } else {
                                    return (
                                        <Markdown 
                                            key={`template-preview-${index}`} 
                                            children={part.text} 
                                            components={{
                                                p: ({children}) => <span>{children}</span>
                                            }}
                                        />
                                    );
                                }
                            })}
                        </p>
                        {chatTemplate.hasFileUpload && 
                            <SymphonyFileHandler 
                                files={chatTemplate.userAddedFiles}
                                setFiles={updatePromptFiles}
                                uploadDisplayText={chatTemplate.fileUploadMessage}
                                uploadRef={fileUploadRef}
                            />
                        }
                        <ButtonRow>
                            <Button
                                onClick={(e) => {
                                    e.preventDefault();
                                    executeTemplate();
                                }}
                                children={"Send Message"}
                            />
                        </ButtonRow>
                    </form>
                }      
            </div>
        </>
    );
};

export default SymphonyChatTemplatePage;
